// extracted by mini-css-extract-plugin
module.exports = {"StatsGrid":"StatsGrid_StatsGrid__X2lKf","paragraph":"StatsGrid_paragraph__cpUt0","tiles":"StatsGrid_tiles__FYPM8","item":"StatsGrid_item__GGyUF","logo":"StatsGrid_logo__TG_GJ"};